import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.regexp.to-string.js";
import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import track from 'utils/track';
import { getCoachAiName } from 'utils/i18n';
import { MINDSET_ID, addMindsetAIIfRequired } from 'utils/mindsetAI';
import useSearchParameter from 'hooks/useSearchParameter';
import Box from 'components/Box';
import Card from 'components/Card';
import CenterContent from 'components/CenterContent';
import CoachAiAvatar from 'components/Avatar/CoachAIAvatar';
import Flex from 'components/Flex';
import Landmark from 'components/Landmark';
import PageBackLink from 'components/PageBackLink';
import PageSection from 'components/PageSection';
import PageTitle from 'components/PageTitle';
import Spinner from 'components/Spinner';
import { HOME_ROUTE } from '../../../routes';
export function CoachAI() {
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var _useState = useState('loading'),
    _useState2 = _slicedToArray(_useState, 2),
    mindsetLoadingStatus = _useState2[0],
    setMindsetLoadingStatus = _useState2[1];
  var _useSearchParameter = useSearchParameter('q'),
    _useSearchParameter2 = _slicedToArray(_useSearchParameter, 1),
    q = _useSearchParameter2[0];
  useEffect(function () {
    function addMindset() {
      return _addMindset.apply(this, arguments);
    }
    function _addMindset() {
      _addMindset = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.prev = 0;
              _context.next = 3;
              return addMindsetAIIfRequired({
                render: true,
                search: q === null || q === void 0 ? void 0 : q.toString()
              });
            case 3:
              _context.next = 9;
              break;
            case 5:
              _context.prev = 5;
              _context.t0 = _context["catch"](0);
              console.error('Mindset:', _context.t0);
              setMindsetLoadingStatus('error');
            case 9:
            case "end":
              return _context.stop();
          }
        }, _callee, null, [[0, 5]]);
      }));
      return _addMindset.apply(this, arguments);
    }
    addMindset();
  }, [q]);
  useEffect(function () {
    // Ideally I would update this row when the component unmounts, but for now I'm creating 2 entries in case the browser is closed
    track('featureUsage', 'mindset');
    var openTime = Date.now();
    return function () {
      var duration = Date.now() - openTime;
      var durationInSeconds = Math.round(duration / 1000);
      track('featureUsage', 'mindset', durationInSeconds);
    };
  }, []);
  return /*#__PURE__*/React.createElement(PageSection, null, /*#__PURE__*/React.createElement(PageBackLink, {
    fallback: HOME_ROUTE,
    mb: "xs"
  }), /*#__PURE__*/React.createElement(Flex, {
    alignItems: "center",
    mb: "s",
    gap: "xs"
  }, /*#__PURE__*/React.createElement(CoachAiAvatar, {
    size: "big"
  }), /*#__PURE__*/React.createElement(PageTitle, {
    size: "large"
  }, getCoachAiName())), /*#__PURE__*/React.createElement(Card, {
    position: "relative",
    height: "70vh",
    pb: "m"
  }, mindsetLoadingStatus === 'loading' && /*#__PURE__*/React.createElement(CenterContent, {
    fillParent: true
  }, /*#__PURE__*/React.createElement(Spinner, null)), mindsetLoadingStatus === 'error' && /*#__PURE__*/React.createElement(CenterContent, {
    fillParent: true
  }, /*#__PURE__*/React.createElement(Landmark, {
    icon: "logout"
  }, t('error_could_not_load_data'))), /*#__PURE__*/React.createElement(Box, {
    height: "100%",
    id: MINDSET_ID,
    onLoadCapture: function onLoadCapture() {
      return setMindsetLoadingStatus('success');
    }
  })));
}
export default CoachAI;